import React from 'react';
import { PrimaryNav } from './nav/primaryNav/primaryNav';
import { SecondaryNav } from './nav/secondaryNav/secondaryNav';
import { FeatureRouter } from './feature/featureRouter';

import styles from './layout.module.css';

export const Layout = () => {
    return <div className={styles.Layout}>
        <div className={styles.PrimaryNav}>
            <PrimaryNav />
        </div>
        <div className={styles.SecondaryNav}>
            <SecondaryNav />
        </div>
        <div className={styles.Feature}>
            <div className={styles.FeatureContent}>
                <FeatureRouter />
            </div>
        </div>
    </div>
}